import { useState } from 'react'
import { CreateUser, VerifyCredentials } from '../api'
import awaitAuth from "./await-auth"
import PlatformAuth from "aldoo-ra/PlatformAuth"
import { PermissionAPI } from "aldoo-ra/Permissions"

const useCreateUserWithCredentials = () => {
    const [state, setState] = useState()
    const [error, setError] = useState()
    //set the credentials once the user is created
    const [, setAuth] = PlatformAuth.useAuth()

    const createUser = async function (credentials) {
        setState(undefined)
        setState("pending")

        const response = await CreateUser(credentials)

        if (response.error) {
            setState(undefined)
            setError(response.error)
            return
        }

        // Check if this is a 3rd party OAuth user (has auth_token immediately)
        const is3rdPartyLogin = !!(credentials.apple_id || credentials.google_id || credentials.facebook_id)

        if (is3rdPartyLogin && response.auth_token) {
            credentials._id = response._id
            setAuth({
                ...credentials,
                auth_token: response.auth_token,
            })

            // Grant role:user permission to the new user
            try {
                await PermissionAPI.grantPermissions(credentials._id, ["role:user"])
            } catch (error) {
                // Don't fail the entire registration process if permission granting fails
            }

            setState("success")
            return
        }

        // Email-based login: wait for magic link verification
        setState("waiting-auth")
        const awaitResult = await awaitAuth(credentials)

        if (!awaitResult.login) {
            setState(undefined)
            return
        }

        //if there is no userID, get it from the server
        if (!credentials._id) {
            const { _id } = await VerifyCredentials(credentials)
            credentials._id = _id
        }
        //set the local authorization object
        setAuth({
            ...credentials,
            auth_token: awaitResult.auth_token,
        })

        // Grant role:user permission to the new user
        try {
            await PermissionAPI.grantPermissions(credentials._id, ["role:user"])
        } catch (error) {
            // Don't fail the entire registration process if permission granting fails
        }

        //mark the login as successful
        setState("success")
    }

    return { state, error, createUser }
}

export default useCreateUserWithCredentials